import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { Profile } from '../../models/profile';
import { FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { CurrentUser } from '../../models/currentUser.model';

@Component({
  selector: 'app-profile-component',
  templateUrl: './profile-component.component.html',
  styleUrls: ['./profile-component.component.css']
})
export class ProfileComponentComponent implements OnInit {

  form:FormGroup;
  currentUser:Profile;
  constructor(
    private userService:UserService,
    private router:Router
    ) {
    this.form = new FormGroup({
      code: new FormControl(),
      name: new FormControl(),
      storageType: new FormControl(),
      firstName: new FormControl(),
      familyName: new FormControl()
    });
   }

  ngOnInit() {
    this.userService.currentUser().subscribe((data:CurrentUser)=>{
      if(data){
        this.currentUser = new Profile(data); 
        this.form.patchValue(this.currentUser);  
      }
    })
  }
  onSubmit(){
    let profile:Profile = this.form.value;
    this.userService.updateProfile(profile).subscribe(()=>{
      this.router.navigate(['home']);
    })
  }
  onCancel(){
    this.router.navigate(['home']);
  }
}
